import { FormControl } from "@angular/forms";

export class AutoCompleteValidators {
  static mustBeInList = (list: Array<any>, key: string) => (control: FormControl) => {
      const validationError = { "mustBeInList": { "valid": false } };
      if (control.value === null) {
        return validationError;
      }
      let isInside: boolean;
      const valueToCompare: string | boolean =
        typeof control.value === "object"
          ? control.value[key].toLowerCase()
          : typeof control.value === "string"
          ? control.value
          : false;
      isInside = list.some((entry) => {
        const currentValue: string = entry[key].toLowerCase();
        return currentValue === valueToCompare || entry[key] === valueToCompare;
      });
      if (isInside) {
        return null;
      } else {
        return validationError;
      }
    };
}
